<template>
  <section class="registration-link half-cut-bg">
    <div class="py-6 flex justify-between px-8">
      <p class="uppercase text-4xl text-gray-400 dark:text-gray-500 uppercase font-bold">
        <span class="text-[#090446]">Ambiguity Assessment Invite</span>
      </p>
      <div class="flex items-center">
        <button
          class="flex items-center px-6 py-2 rounded-md bg-[#0A0446] text-white text-center text-sm shadow hover:bg-[#0A0446]/90 transition-colors"
          @click="copyPublicAssessmentLink">
          <svg v-if="isPublicLinkCopied" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2 text-green-400" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
          <span>{{ isPublicLinkCopied ? 'Copied!' : 'Copy Public Link' }}</span>
        </button>
      </div>
    </div>


    <!-- card-10 stat -->
    <div class="w-full">
      <div class="mx-5 flex flex-wrap space-x-2 space-y-1">
        <button
          class="flex items-center font-sixe-[20px] px-12 py-2 rounded-md bg-[#BE0858] text-white text-center text-md shadow">

          <svg width="24" height="24" viewBox="0 0 40 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19.6083 10.9267C20.6888 10.9267 21.7451 10.6063 22.6435 10.006C23.542 9.40564 24.2422 8.55238 24.6557 7.55409C25.0693 6.55579 25.1774 5.45729 24.9666 4.39751C24.7558 3.33772 24.2355 2.36424 23.4714 1.60018C22.7074 0.836117 21.7339 0.315784 20.6741 0.104979C19.6143 -0.105825 18.5158 0.00236697 17.5175 0.415875C16.5192 0.829383 15.666 1.52963 15.0657 2.42808C14.4653 3.32652 14.1449 4.3828 14.1449 5.46335C14.1466 6.91182 14.7227 8.30049 15.7469 9.32471C16.7711 10.3489 18.1598 10.9251 19.6083 10.9267ZM19.6083 1.41513C20.4089 1.41513 21.1916 1.65256 21.8573 2.09738C22.5231 2.54221 23.0419 3.17445 23.3483 3.91417C23.6547 4.65388 23.7349 5.46784 23.5787 6.25312C23.4225 7.0384 23.0369 7.75972 22.4708 8.32588C21.9046 8.89203 21.1833 9.27759 20.398 9.43379C19.6128 9.58999 18.7988 9.50982 18.0591 9.20342C17.3194 8.89702 16.6871 8.37815 16.2423 7.71242C15.7975 7.0467 15.5601 6.26401 15.5601 5.46335C15.5613 4.39007 15.9882 3.36109 16.7471 2.60216C17.506 1.84324 18.535 1.41634 19.6083 1.41513ZM31.4434 13.8817C32.3114 13.8817 33.1598 13.6244 33.8815 13.1421C34.6032 12.6599 35.1657 11.9745 35.4978 11.1727C35.83 10.3708 35.9169 9.48839 35.7476 8.6371C35.5782 7.78582 35.1603 7.00387 34.5465 6.39013C33.9328 5.77639 33.1508 5.35843 32.2996 5.1891C31.4483 5.01977 30.5659 5.10667 29.764 5.43883C28.9621 5.77098 28.2767 6.33346 27.7945 7.05514C27.3123 7.77683 27.0549 8.62529 27.0549 9.49325C27.0562 10.6568 27.519 11.7722 28.3417 12.595C29.1644 13.4177 30.2799 13.8804 31.4434 13.8817ZM31.4434 6.51998C32.0315 6.51998 32.6063 6.69437 33.0953 7.02109C33.5843 7.34781 33.9654 7.81219 34.1904 8.3555C34.4155 8.89881 34.4743 9.49666 34.3596 10.0734C34.2449 10.6502 33.9617 11.18 33.5458 11.5958C33.13 12.0117 32.6002 12.2948 32.0234 12.4096C31.4466 12.5243 30.8488 12.4654 30.3055 12.2403C29.7622 12.0153 29.2978 11.6342 28.9711 11.1452C28.6444 10.6562 28.47 10.0813 28.4701 9.49325C28.471 8.70502 28.7846 7.94935 29.342 7.39203C29.8995 6.8347 30.6552 6.52123 31.4434 6.52038V6.51998ZM7.75434 13.8817C8.6223 13.8817 9.47077 13.6244 10.1925 13.1421C10.9141 12.6599 11.4766 11.9745 11.8088 11.1727C12.1409 10.3708 12.2278 9.48839 12.0585 8.6371C11.8892 7.78582 11.4712 7.00387 10.8575 6.39013C10.2437 5.77639 9.46178 5.35843 8.61049 5.1891C7.75921 5.01977 6.87684 5.10667 6.07495 5.43883C5.27306 5.77098 4.58767 6.33346 4.10546 7.05514C3.62324 7.77683 3.36586 8.62529 3.36586 9.49325C3.36718 10.6567 3.82995 11.7722 4.65267 12.5949C5.47538 13.4176 6.59085 13.8804 7.75434 13.8817ZM7.75434 6.51998C8.34242 6.51998 8.91729 6.69437 9.40626 7.02109C9.89522 7.34781 10.2763 7.81219 10.5014 8.3555C10.7264 8.89881 10.7853 9.49666 10.6706 10.0734C10.5558 10.6502 10.2726 11.18 9.85679 11.5958C9.44095 12.0117 8.91115 12.2948 8.33437 12.4096C7.75759 12.5243 7.15975 12.4654 6.61644 12.2403C6.07313 12.0153 5.60876 11.6342 5.28206 11.1452C4.95535 10.6562 4.78098 10.0813 4.781 9.49325C4.782 8.70502 5.09559 7.94937 5.653 7.39205C6.21041 6.83473 6.96611 6.52125 7.75434 6.52038V6.51998ZM39.1131 19.0785C38.9684 17.8042 38.4544 16.5633 37.7031 15.6738C36.8092 14.6155 35.6326 14.1001 34.3888 14.2252C34.2435 14.2396 34.1062 14.2987 33.9958 14.3944C33.1195 15.1532 32.2879 15.5047 31.4517 15.4723C31.4327 15.4715 31.4138 15.4715 31.395 15.4723C30.5577 15.5055 29.7269 15.1531 28.8509 14.3944C28.7405 14.2987 28.6032 14.2396 28.4578 14.2252C28.3073 14.2102 28.156 14.2046 28.0049 14.2084C27.8616 13.9908 27.7057 13.7817 27.538 13.5822C26.4283 12.2684 24.9712 11.6293 23.4342 11.7828C23.2888 11.7972 23.1515 11.8563 23.0411 11.952C21.8836 12.9543 20.7297 13.439 19.6104 13.3949C19.5915 13.3941 19.5727 13.3941 19.5538 13.3949C18.4354 13.4383 17.2805 12.9543 16.123 11.952C16.0126 11.8563 15.8753 11.7972 15.7299 11.7828C14.1936 11.6292 12.7359 12.2684 11.6261 13.5822C11.4583 13.782 11.3022 13.9914 11.1587 14.2093C11.0052 14.2048 10.8516 14.21 10.6988 14.225C10.5535 14.2394 10.4161 14.2985 10.3057 14.3942C9.42962 15.1529 8.59878 15.5041 7.76158 15.472C7.74271 15.4712 7.72381 15.4712 7.70489 15.472C6.86745 15.5035 6.03692 15.1528 5.16072 14.3941C5.05032 14.2984 4.91299 14.2394 4.76763 14.225C3.52381 14.1001 2.34729 14.6153 1.45347 15.6736C0.702117 16.5631 0.188188 17.8042 0.0434516 19.0783C-0.258443 21.7356 1.03404 23.7108 3.25894 23.9943C3.28859 23.9981 3.31845 24 3.34833 24H12.1193C12.1492 24 12.1791 23.9981 12.2087 23.9943C12.4739 23.9607 12.735 23.9001 12.9879 23.8134C13.2622 23.8979 13.5432 23.9584 13.8279 23.9943C13.8576 23.9981 13.8874 24 13.9172 24H25.248C25.2779 24 25.3078 23.9981 25.3374 23.9943C25.6204 23.9586 25.8997 23.8987 26.1724 23.8152C26.4247 23.9009 26.6849 23.9609 26.9493 23.9943C26.9789 23.9981 27.0088 24 27.0387 24H35.8085C35.8383 24 35.8682 23.9981 35.8978 23.9943C38.1228 23.7111 39.415 21.7355 39.1131 19.0785ZM4.71228 22.5851V19.8895C4.71228 19.7019 4.63774 19.5219 4.50504 19.3892C4.37235 19.2565 4.19238 19.182 4.00472 19.182C3.81706 19.182 3.63709 19.2565 3.50439 19.3892C3.3717 19.5219 3.29715 19.7019 3.29715 19.8895V22.5678C1.69444 22.2769 1.2883 20.6731 1.45135 19.2382C1.65859 17.4134 2.81058 15.6223 4.41133 15.6223H4.42438C5.50146 16.4991 6.6154 16.9232 7.73485 16.8872C8.56907 16.9137 9.39912 16.685 10.2134 16.2047C10.039 16.7472 9.91828 17.3054 9.85314 17.8715C9.68757 19.3294 9.91792 20.7157 10.5019 21.7752C10.6612 22.0651 10.8519 22.3367 11.0705 22.5849L4.71228 22.5851ZM25.2017 22.5851H25.11V18.8956C25.11 18.708 25.0354 18.528 24.9027 18.3953C24.7701 18.2626 24.5901 18.1881 24.4024 18.1881C24.2148 18.1881 24.0348 18.2626 23.9021 18.3953C23.7694 18.528 23.6949 18.708 23.6949 18.8956V22.5851H15.4714V18.8956C15.4714 18.708 15.3968 18.528 15.2641 18.3953C15.1314 18.2626 14.9515 18.1881 14.7638 18.1881C14.5761 18.1881 14.3962 18.2626 14.2635 18.3953C14.1308 18.528 14.0562 18.708 14.0562 18.8956V22.5851H13.9646C11.6267 22.2613 11.033 20.0249 11.2595 18.0309C11.5379 15.5796 13.1049 13.1757 15.289 13.1757C15.3198 13.1757 15.3506 13.1762 15.3817 13.1772C16.7534 14.3098 18.1664 14.8586 19.5833 14.8099C21.0026 14.8593 22.4135 14.3097 23.7848 13.1772C26.0176 13.1057 27.6248 15.5452 27.9071 18.0309C28.1327 20.0249 27.5393 22.2613 25.2013 22.5851H25.2017ZM35.8615 22.5678V19.8895C35.8615 19.7019 35.787 19.5219 35.6543 19.3892C35.5216 19.2565 35.3416 19.182 35.154 19.182C34.9663 19.182 34.7863 19.2565 34.6536 19.3892C34.5209 19.5219 34.4464 19.7019 34.4464 19.8895V22.5851H28.0952C28.3138 22.3368 28.5045 22.0653 28.6639 21.7753C29.2478 20.7159 29.4782 19.3296 29.3126 17.8716C29.2477 17.3075 29.1275 16.7511 28.9539 16.2104C29.7655 16.6873 30.5926 16.9147 31.4235 16.8876C32.5431 16.9237 33.6563 16.4995 34.7339 15.6228H34.747C36.3475 15.6228 37.4998 17.414 37.707 19.2386C37.8701 20.6734 37.4639 22.277 35.8609 22.5678H35.8615Z"
              fill="white" />
          </svg>

          <span class="flex-1 text-white ml-3 whitespace-nowrap">Candidates</span>
        </button>
        <router-link to="/admin/survery-reports">
          <button
            class="flex items-center font-sixe-[20px] px-12 py-2  rounded-md bg-white text-black text-center text-md shadow">

            <svg width="24" height="24" viewBox="0 0 40 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19.6083 10.9267C20.6888 10.9267 21.7451 10.6063 22.6435 10.006C23.542 9.40564 24.2422 8.55238 24.6557 7.55409C25.0693 6.55579 25.1774 5.45729 24.9666 4.39751C24.7558 3.33772 24.2355 2.36424 23.4714 1.60018C22.7074 0.836117 21.7339 0.315784 20.6741 0.104979C19.6143 -0.105825 18.5158 0.00236697 17.5175 0.415875C16.5192 0.829383 15.666 1.52963 15.0657 2.42808C14.4653 3.32652 14.1449 4.3828 14.1449 5.46335C14.1466 6.91182 14.7227 8.30049 15.7469 9.32471C16.7711 10.3489 18.1598 10.9251 19.6083 10.9267ZM19.6083 1.41513C20.4089 1.41513 21.1916 1.65256 21.8573 2.09738C22.5231 2.54221 23.0419 3.17445 23.3483 3.91417C23.6547 4.65388 23.7349 5.46784 23.5787 6.25312C23.4225 7.0384 23.0369 7.75972 22.4708 8.32588C21.9046 8.89203 21.1833 9.27759 20.398 9.43379C19.6128 9.58999 18.7988 9.50982 18.0591 9.20342C17.3194 8.89702 16.6871 8.37815 16.2423 7.71242C15.7975 7.0467 15.5601 6.26401 15.5601 5.46335C15.5613 4.39007 15.9882 3.36109 16.7471 2.60216C17.506 1.84324 18.535 1.41634 19.6083 1.41513ZM31.4434 13.8817C32.3114 13.8817 33.1598 13.6244 33.8815 13.1421C34.6032 12.6599 35.1657 11.9745 35.4978 11.1727C35.83 10.3708 35.9169 9.48839 35.7476 8.6371C35.5782 7.78582 35.1603 7.00387 34.5465 6.39013C33.9328 5.77639 33.1508 5.35843 32.2996 5.1891C31.4483 5.01977 30.5659 5.10667 29.764 5.43883C28.9621 5.77098 28.2767 6.33346 27.7945 7.05514C27.3123 7.77683 27.0549 8.62529 27.0549 9.49325C27.0562 10.6568 27.519 11.7722 28.3417 12.595C29.1644 13.4177 30.2799 13.8804 31.4434 13.8817ZM31.4434 6.51998C32.0315 6.51998 32.6063 6.69437 33.0953 7.02109C33.5843 7.34781 33.9654 7.81219 34.1904 8.3555C34.4155 8.89881 34.4743 9.49666 34.3596 10.0734C34.2449 10.6502 33.9617 11.18 33.5458 11.5958C33.13 12.0117 32.6002 12.2948 32.0234 12.4096C31.4466 12.5243 30.8488 12.4654 30.3055 12.2403C29.7622 12.0153 29.2978 11.6342 28.9711 11.1452C28.6444 10.6562 28.47 10.0813 28.4701 9.49325C28.471 8.70502 28.7846 7.94935 29.342 7.39203C29.8995 6.8347 30.6552 6.52123 31.4434 6.52038V6.51998ZM7.75434 13.8817C8.6223 13.8817 9.47077 13.6244 10.1925 13.1421C10.9141 12.6599 11.4766 11.9745 11.8088 11.1727C12.1409 10.3708 12.2278 9.48839 12.0585 8.6371C11.8892 7.78582 11.4712 7.00387 10.8575 6.39013C10.2437 5.77639 9.46178 5.35843 8.61049 5.1891C7.75921 5.01977 6.87684 5.10667 6.07495 5.43883C5.27306 5.77098 4.58767 6.33346 4.10546 7.05514C3.62324 7.77683 3.36586 8.62529 3.36586 9.49325C3.36718 10.6567 3.82995 11.7722 4.65267 12.5949C5.47538 13.4176 6.59085 13.8804 7.75434 13.8817ZM7.75434 6.51998C8.34242 6.51998 8.91729 6.69437 9.40626 7.02109C9.89522 7.34781 10.2763 7.81219 10.5014 8.3555C10.7264 8.89881 10.7853 9.49666 10.6706 10.0734C10.5558 10.6502 10.2726 11.18 9.85679 11.5958C9.44095 12.0117 8.91115 12.2948 8.33437 12.4096C7.75759 12.5243 7.15975 12.4654 6.61644 12.2403C6.07313 12.0153 5.60876 11.6342 5.28206 11.1452C4.95535 10.6562 4.78098 10.0813 4.781 9.49325C4.782 8.70502 5.09559 7.94937 5.653 7.39205C6.21041 6.83473 6.96611 6.52125 7.75434 6.52038V6.51998ZM39.1131 19.0785C38.9684 17.8042 38.4544 16.5633 37.7031 15.6738C36.8092 14.6155 35.6326 14.1001 34.3888 14.2252C34.2435 14.2396 34.1062 14.2987 33.9958 14.3944C33.1195 15.1532 32.2879 15.5047 31.4517 15.4723C31.4327 15.4715 31.4138 15.4715 31.395 15.4723C30.5577 15.5055 29.7269 15.1531 28.8509 14.3944C28.7405 14.2987 28.6032 14.2396 28.4578 14.2252C28.3073 14.2102 28.156 14.2046 28.0049 14.2084C27.8616 13.9908 27.7057 13.7817 27.538 13.5822C26.4283 12.2684 24.9712 11.6293 23.4342 11.7828C23.2888 11.7972 23.1515 11.8563 23.0411 11.952C21.8836 12.9543 20.7297 13.439 19.6104 13.3949C19.5915 13.3941 19.5727 13.3941 19.5538 13.3949C18.4354 13.4383 17.2805 12.9543 16.123 11.952C16.0126 11.8563 15.8753 11.7972 15.7299 11.7828C14.1936 11.6292 12.7359 12.2684 11.6261 13.5822C11.4583 13.782 11.3022 13.9914 11.1587 14.2093C11.0052 14.2048 10.8516 14.21 10.6988 14.225C10.5535 14.2394 10.4161 14.2985 10.3057 14.3942C9.42962 15.1529 8.59878 15.5041 7.76158 15.472C7.74271 15.4712 7.72381 15.4712 7.70489 15.472C6.86745 15.5035 6.03692 15.1528 5.16072 14.3941C5.05032 14.2984 4.91299 14.2394 4.76763 14.225C3.52381 14.1001 2.34729 14.6153 1.45347 15.6736C0.702117 16.5631 0.188188 17.8042 0.0434516 19.0783C-0.258443 21.7356 1.03404 23.7108 3.25894 23.9943C3.28859 23.9981 3.31845 24 3.34833 24H12.1193C12.1492 24 12.1791 23.9981 12.2087 23.9943C12.4739 23.9607 12.735 23.9001 12.9879 23.8134C13.2622 23.8979 13.5432 23.9584 13.8279 23.9943C13.8576 23.9981 13.8874 24 13.9172 24H25.248C25.2779 24 25.3078 23.9981 25.3374 23.9943C25.6204 23.9586 25.8997 23.8987 26.1724 23.8152C26.4247 23.9009 26.6849 23.9609 26.9493 23.9943C26.9789 23.9981 27.0088 24 27.0387 24H35.8085C35.8383 24 35.8682 23.9981 35.8978 23.9943C38.1228 23.7111 39.415 21.7355 39.1131 19.0785ZM4.71228 22.5851V19.8895C4.71228 19.7019 4.63774 19.5219 4.50504 19.3892C4.37235 19.2565 4.19238 19.182 4.00472 19.182C3.81706 19.182 3.63709 19.2565 3.50439 19.3892C3.3717 19.5219 3.29715 19.7019 3.29715 19.8895V22.5678C1.69444 22.2769 1.2883 20.6731 1.45135 19.2382C1.65859 17.4134 2.81058 15.6223 4.41133 15.6223H4.42438C5.50146 16.4991 6.6154 16.9232 7.73485 16.8872C8.56907 16.9137 9.39912 16.685 10.2134 16.2047C10.039 16.7472 9.91828 17.3054 9.85314 17.8715C9.68757 19.3294 9.91792 20.7157 10.5019 21.7752C10.6612 22.0651 10.8519 22.3367 11.0705 22.5849L4.71228 22.5851ZM25.2017 22.5851H25.11V18.8956C25.11 18.708 25.0354 18.528 24.9027 18.3953C24.7701 18.2626 24.5901 18.1881 24.4024 18.1881C24.2148 18.1881 24.0348 18.2626 23.9021 18.3953C23.7694 18.528 23.6949 18.708 23.6949 18.8956V22.5851H15.4714V18.8956C15.4714 18.708 15.3968 18.528 15.2641 18.3953C15.1314 18.2626 14.9515 18.1881 14.7638 18.1881C14.5761 18.1881 14.3962 18.2626 14.2635 18.3953C14.1308 18.528 14.0562 18.708 14.0562 18.8956V22.5851H13.9646C11.6267 22.2613 11.033 20.0249 11.2595 18.0309C11.5379 15.5796 13.1049 13.1757 15.289 13.1757C15.3198 13.1757 15.3506 13.1762 15.3817 13.1772C16.7534 14.3098 18.1664 14.8586 19.5833 14.8099C21.0026 14.8593 22.4135 14.3097 23.7848 13.1772C26.0176 13.1057 27.6248 15.5452 27.9071 18.0309C28.1327 20.0249 27.5393 22.2613 25.2013 22.5851H25.2017ZM35.8615 22.5678V19.8895C35.8615 19.7019 35.787 19.5219 35.6543 19.3892C35.5216 19.2565 35.3416 19.182 35.154 19.182C34.9663 19.182 34.7863 19.2565 34.6536 19.3892C34.5209 19.5219 34.4464 19.7019 34.4464 19.8895V22.5851H28.0952C28.3138 22.3368 28.5045 22.0653 28.6639 21.7753C29.2478 20.7159 29.4782 19.3296 29.3126 17.8716C29.2477 17.3075 29.1275 16.7511 28.9539 16.2104C29.7655 16.6873 30.5926 16.9147 31.4235 16.8876C32.5431 16.9237 33.6563 16.4995 34.7339 15.6228H34.747C36.3475 15.6228 37.4998 17.414 37.707 19.2386C37.8701 20.6734 37.4639 22.277 35.8609 22.5678H35.8615Z"
                fill="black" />
            </svg>

            <span class="flex-1 text-[#0A0446] ml-3 whitespace-nowrap">Manage Surveys</span>
          </button>
        </router-link>
      </div>
      <div class="pt-6 px-8">
        <form class="w-full lg:w-2/3">
          <div class="my-2">
            <!-- Flex container to align items horizontally -->
            <div class="flex flex-col md:flex-row md:space-x-4">
              <div class="mb-2 md:mb-0 w-full">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="name">
                  Insert Name
                </label>
                <input
                  class="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-8 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="name" type="text" placeholder="Enter Name" v-model="sendEmail.name">
                <p class="text-red-500 text-xs italic hidden">Please fill out this field.</p>
              </div>
              <div class="mb-2 md:mb-0 w-full">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="forgot-email">
                  Insert an email to send invite:
                </label>
                <input
                  class="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-8 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="forgot-email" type="email" placeholder="Enter email" v-model="sendEmail.email">
                <p class="text-red-500 text-xs italic hidden">Please fill out this field.</p>
              </div>
            </div>
            <div class="mt-4">
              <button type="button"
                class="b-0 flex items-center font-sixe-[20px] px-12 py-2 rounded-md bg-[#0A0446] text-white text-center text-md"
                @click="sendAdminSurveyInviteLinkToEmail" :disabled="isLoading">
                <svg v-if="isLoading" class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg"
                  fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                </svg>
                <!-- Show button text when not loading -->
                <span v-else>Invite</span>
              </button>
            </div>
          </div>
        </form>
      </div>

      <!-- NEW CSV UPLOAD FEATURE -->
      <div class="pt-6 px-8">
        <form class="w-full">
          <div class="my-2">
            <div class="mb-4">
              <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="csv-file">
                Or Upload CSV File with Name and Email Columns
              </label>
              <div class="flex flex-col md:flex-row md:space-x-4">
                <div class="mb-2 md:mb-0 w-full">
                  <input
                    class="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-8 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="csv-file"
                    type="file"
                    accept=".csv,.xlsx,.xls"
                    @change="handleFileUpload">
                    <p class="text-gray-600 text-xs italic">Upload CSV or Excel file with 'name' and 'email' columns.</p>
                    <a href="#" class="text-blue-600 text-xs underline" @click.prevent="downloadTemplate">Download Template</a>
                  <!-- Download template link -->
                
                </div>
                <div class="flex items-start w-full">
                  <button type="button"
                    class="b-0 flex items-center font-sixe-[20px] px-12 py-2 rounded-md bg-[#0A0446] text-white text-center text-md"
                    @click="uploadCSVFile"
                    :disabled="isCSVUploading || !csvFile">
                    <svg v-if="isCSVUploading" class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg"
                      fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                    </svg>
                    <span v-else>Upload & Invite</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- employee list table -->
      <div class="py-6 px-8">
        <div class="flex space-x-2 py-6">
          <form class="flex items-center">
            <label for="simple-search" class="sr-only">Search</label>
            <div class="relative w-full">
              <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg aria-hidden="true" class="w-5 h-5 text-gray-500" fill="currentColor" viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    clip-rule="evenodd"></path>
                </svg>
              </div>
              <input type="text" id="simple-search"
                class="px-14 bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5"
                placeholder="Search by name" required v-model="getEmpData.name" v-on:keyup="getInvitedEmployeesList">
            </div>
          </form>

          <form class="flex items-center">
            <label for="simple-search" class="sr-only">Search</label>
            <div class="relative w-full">
              <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg aria-hidden="true" class="w-5 h-5 text-gray-500" fill="currentColor" viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    clip-rule="evenodd"></path>
                </svg>
              </div>
              <input type="text" id="simple-search"
                class="px-14 bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5"
                placeholder="Search by email" required v-model="getEmpData.email" v-on:keyup="getInvitedEmployeesList">
            </div>
          </form>
        </div>
        <div class="relative overflow-x-auto shadow-md">
          <table class="w-full text-sm text-center text-white">
            <thead class="text-xs text-white bg-[#0A0446]">
              <tr>
                <th scope="col" class="px-6 py-4 rounded-tl-lg border-r border-gray-700">
                  Name
                </th>
                <th scope="col" class="px-6 py-4 border-r border-gray-700">
                  Email
                </th>
                <th scope="col" class="px-6 py-4 border-r border-gray-700">
                  Invitation Link
                </th>
                <th scope="col" class="px-6 py-4 border-r border-gray-700">
                  Invited on
                </th>
                <th scope="col" class="px-6 py-4 rounded-tr-lg">
                  Action
                </th>
              </tr>
            </thead>
            <tbody class="text-[#090446]">
              <tr class="bg-white hover:bg-gray-50" v-if="isTableLoading">
                <td scope="row" class="px-6 py-4 border-r border-gray-300 font-medium text-center whitespace-nowrap"
                  colspan="5">
                  Processing ...
                </td>
              </tr>
              <tr class="bg-white hover:bg-gray-50" v-if="!isTableLoading" v-for="e in employeesList.data"
                v-bind:key="e.id">
                <td scope="row" class="px-6 py-4 border-r border-gray-300 font-medium whitespace-nowrap">
                  {{ e.name }}
                </td>
                <td class="px-6 py-4 border-r border-gray-300">
                  {{ e.email }}
                </td>
                <td class="px-6 py-4 border-r border-gray-300">
                  <div class="flex items-center justify-center">
                    <input type="text" class="w-32 sm:w-60 px-2 py-1 text-sm border rounded mr-2 bg-gray-50" 
                          :id="'invite-link-' + e.id" 
                          :value="e.survey_invite_link ? `${baseUrl}/assessment-welcome/${e.survey_invite_link}` : `${baseUrl}/assessment-welcome/${e.id}`" 
                          readonly />
                    <button 
                      @click="copyInvitationLink(e.id)" 
                      class="px-2 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded border text-xs flex items-center">
                      <svg v-if="copiedLinkId === e.id" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                      </svg>
                      <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2" />
                      </svg>
                      <span>{{ copiedLinkId === e.id ? 'Copied!' : 'Copy' }}</span>
                    </button>
                  </div>
                </td>
                <td class="px-6 py-4 border-r border-gray-300">
                  {{ formatDate(e.created_at) }}
                </td>
                <td
                  class="px-6 py-4 border-r border-gray-300 flex items-center justify-center space-x-2 px-1 border-r border-gray-300">
                  <button
                    class="flex items-center px-3 py-1 rounded-md bg-white text-black text-center text-md font-medium shadow border-2"
                    @click="getInvitedEmployee(e.id)">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_143_2408)">
                        <path
                          d="M7.33301 2.66666H4.53301C3.4129 2.66666 2.85285 2.66666 2.42503 2.88464C2.0487 3.07639 1.74274 3.38235 1.55099 3.75867C1.33301 4.1865 1.33301 4.74655 1.33301 5.86666V11.4667C1.33301 12.5868 1.33301 13.1468 1.55099 13.5746C1.74274 13.951 2.0487 14.2569 2.42503 14.4487C2.85285 14.6667 3.4129 14.6667 4.53301 14.6667H10.133C11.2531 14.6667 11.8132 14.6667 12.241 14.4487C12.6173 14.2569 12.9233 13.951 13.115 13.5746C13.333 13.1468 13.333 12.5868 13.333 11.4667V8.66666M5.33299 10.6667H6.44935C6.77547 10.6667 6.93853 10.6667 7.09198 10.6298C7.22803 10.5972 7.35809 10.5433 7.47739 10.4702C7.61194 10.3877 7.72724 10.2724 7.95785 10.0418L14.333 3.66666C14.8853 3.11437 14.8853 2.21894 14.333 1.66666C13.7807 1.11437 12.8853 1.11437 12.333 1.66665L5.95783 8.04182C5.72723 8.27242 5.61193 8.38772 5.52947 8.52228C5.45637 8.64157 5.40249 8.77163 5.36983 8.90768C5.33299 9.06113 5.33299 9.22419 5.33299 9.55031V10.6667Z"
                          stroke="#0A0446" stroke-linecap="round" stroke-linejoin="round" />
                      </g>
                      <defs>
                        <clipPath id="clip0_143_2408">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span class="flex-1 text-[#0A0446] ml-3 whitespace-nowrap">Edit</span>
                  </button>

                  <button
                    class="flex items-center px-3 py-1 rounded-md bg-white text-black text-center text-md shadow border-2"
                    @click="resendInvitedEmployee(e.id)">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M22 2L11 13" stroke="#6A6767" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="#6A6767" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>

                    <span class="flex-1 font-medium text-gray-800 ml-3 whitespace-nowrap">Resend</span>
                  </button>

                  <button
                    class="flex items-center px-3 py-1 rounded-md bg-white text-black text-center text-md shadow border-2"
                    @click="deleteInvitedEmployee(e.id)">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M6 2H10M2 4H14M12.6667 4L12.1991 11.0129C12.129 12.065 12.0939 12.5911 11.8667 12.99C11.6666 13.3412 11.3648 13.6235 11.0011 13.7998C10.588 14 10.0607 14 9.00623 14H6.99377C5.93927 14 5.41202 14 4.99889 13.7998C4.63517 13.6235 4.33339 13.3412 4.13332 12.99C3.90607 12.5911 3.871 12.065 3.80086 11.0129L3.33333 4"
                        stroke="#6A6767" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    <span class="flex-1 font-medium text-gray-800 ml-3 whitespace-nowrap">Delete</span>
                  </button>

                </td>
              </tr>
            </tbody>
          </table>
          <pagination :data="employeesList" @pagination-change-page="getInvitedEmployeesList" />
        </div>
      </div>
    </div>

    <!-- Update Modal -->
    <b-modal id="update-invited-employee-modal" title="Update Employee" :hide-footer=hideFooter>
      <form>
        <div id="update-details">
          <div class="form-group">
            <label>Name <span class="err">*</span></label>
            <input type="text" class="form-control" id="name" placeholder="Name" v-model="employeeUpdate.name">
          </div>
          <div class="form-group">
            <label>Email <span class="err">*</span></label>
            <input type="text" class="form-control" id="email" placeholder="email" v-model="employeeUpdate.email">
          </div>

          <button type="button" @click="updateEmployee" class="btn btn-primary bg-[#0A0446]"
            :disabled="employeeUpdate.disabled">
            <svg v-if="isUpdateLoading" class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg"
              fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
            </svg>
            <!-- Show button text when not loading -->
            <span v-else>Update</span>
          </button>
        </div>
      </form>
    </b-modal>
  </section>
</template>

<script>
/* eslint-disable */
import Api from '../../../router/api'
import AppMixin from '../../../mixins/AppMixin'
import moment from 'moment';

export default {
  name: 'NonEmployeeInvitations',
  data() {
    return {
      employeesList: {},
      employeesLength: 0,
      hideFooter: true,
      sendEmail: {
        'email': '',
        'name': '',
        'disabled': false
      },
      getEmpData: {
        'sortBy': '',
        'name': '',
        'email': '',
        'sortOrder': ''
      },
      employeeUpdate: {
        'id': '',
        'name': '',
        'email': '',
        'disabled': false
      },
      linkCopied: false,
      isLoading: false,
      isUpdateLoading: false,
      isTableLoading: true,
      csvFile: null,
      isCSVUploading: false,
      baseUrl: process.env.VUE_APP_URL || window.location.origin,
      isPublicLinkCopied: false,
      publicAssessmentUrl: 'https://cogdynamism.mpact-int.com/assessment',
    }
  },
  mixins: [AppMixin],
  methods: {
    // CSV Upload Methods
    handleFileUpload(event) {
      this.csvFile = event.target.files[0];
    },
    
    uploadCSVFile() {
      if (!this.csvFile) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Please select a CSV file first",
          showConfirmButton: true,
          confirmButtonColor: '#0A0446'
        });
        return;
      }

      const formData = new FormData();
      formData.append('csv_file', this.csvFile);
      
      this.isCSVUploading = true;
      
      Api.uploadCSVForInvitations(formData)
        .then(response => {
          this.$swal({
            icon: "success",
            title: "Success",
            text: `${response.data.sent_count} invitations sent successfully!`,
            showConfirmButton: true,
            confirmButtonColor: '#0A0446'
          }).then(() => {
            this.isCSVUploading = false;
            this.csvFile = null;
            document.getElementById('csv-file').value = '';
            this.getInvitedEmployeesList();
          });
        })
        .catch(error => {
          this.isCSVUploading = false;
          this.$swal({
            icon: "error",
            title: "Error",
            text: error.response.data.message || "Failed to process CSV file",
            showConfirmButton: true,
            confirmButtonColor: '#0A0446'
          });
        });
    },
    
    
    // Existing methods
    getInvitedEmployee: function (id) {
      let that = this
      Api.getInvitedEmployee(id).then(response => {
        that.$bvModal.show('update-invited-employee-modal')
        that.employeeUpdate.id = response.data.res.id
        that.employeeUpdate.name = response.data.res.name
        that.employeeUpdate.email = response.data.res.email
      });
    },
    
    updateEmployee: function () {
      let that = this;

      if (!that.employeeUpdate.name || !that.employeeUpdate.email) {
        this.$swal({
          icon: "error",
          title: "error",
          text: "Please fill all required fields",
          showConfirmButton: true,
          confirmButtonColor: '#0A0446'
        });
      } else {
        that.employeeUpdate.disabled = true;
        this.isUpdateLoading = true
        Api.updateInvitedListUser(that.employeeUpdate).then(response => {
          that.employeeUpdate.disabled = false;
          that.isUpdateLoading = false;
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Invitation details updated successfully",
            showConfirmButton: true,
            confirmButtonColor: '#0A0446'
          }).then(function () {
            that.isUpdateLoading = false;
            that.employeeUpdate.disabled = false;
            that.$bvModal.hide('update-invited-employee-modal')
            that.getInvitedEmployeesList()
          });
        }
        ).catch((error) => {
          this.$swal({
            icon: "error",
            title: "error",
            text: error.response.data.message,
            showConfirmButton: true,
            confirmButtonColor: '#0A0446'
          }).then(function () {
            that.employeeUpdate.disabled = false;
            that.isUpdateLoading = false
          });
        });
      }
    },
    
    formatDate(date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a'); // Example format: "January 1st 2021, 2:30:00 pm"
    },
    
    deleteInvitedEmployee: function (id) {
      let that = this
      this.$swal({
        title: 'Are you sure?',
        text: 'All the related info will be deleted, you wont be able to revert !',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        confirmButtonColor: '#0A0446'
      }).then((result) => {
        if (result.value) {
          Api.deleteInvitedEmployee(id).then(response => {
            this.$swal({
              icon: "success",
              title: "success",
              text: "Deleted Successfully",
              showConfirmButton: true,
              confirmButtonColor: '#0A0446'
            }).then(() => {
              that.getInvitedEmployeesList()
            });
          }
          ).catch((error) => {
            this.$swal({
              icon: "error",
              title: "error",
              text: error.response.data.message,
              showConfirmButton: true,
              confirmButtonColor: '#0A0446'
            });
          });
        }
      })
    },
    
    resendInvitedEmployee: function (id) {
      let that = this
      this.$swal({
        title: 'Are you sure?',
        text: 'It will send the invitation again to this member.',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes, send it',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        confirmButtonColor: '#0A0446'
      }).then((result) => {
        if (result.value) {
          Api.reSendAdminSurveyInviteLinkToEmail(id).then(response => {
            this.$swal({
              icon: "success",
              title: "success",
              text: "Invitation Resend Successfully",
              showConfirmButton: true,
              confirmButtonColor: '#0A0446'
            }).then(() => {
              that.getInvitedEmployeesList()
            });
          }
          ).catch((error) => {
            this.$swal({
              icon: "error",
              title: "error",
              text: error.response.data.message,
              showConfirmButton: true,
              confirmButtonColor: '#0A0446'
            });
          });
        }
      })
    },
    
    sendAdminSurveyInviteLinkToEmail: function () {
      let that = this
      if (!that.sendEmail.email) {
        this.$swal({
          icon: "error",
          title: "error",
          text: "Please Enter Email",
          showConfirmButton: true,
          confirmButtonColor: '#0A0446'
        });
      } else {
        that.sendEmail.disabled = true
        this.isLoading = true
        Api.sendAdminSurveyInviteLinkToEmail(that.sendEmail).then(response => {
          this.$swal({
            icon: "success",
            title: "success",
            text: "Email sent successfully",
            showConfirmButton: true,
            confirmButtonColor: '#0A0446'
          }).then(() => {
            this.isLoading = false
            that.sendEmail.email = ''
            that.sendEmail.name = ''
            that.sendEmail.disabled = false
            that.getInvitedEmployeesList()
          });
        }
        ).catch((error) => {
          that.sendEmail.disabled = false
          this.isLoading = false
          this.$swal({
            icon: "error",
            title: "error",
            text: error.response.data.message,
            showConfirmButton: true,
            confirmButtonColor: '#0A0446'
          });
        });
      }
    },

    downloadTemplate() {
      // Show loading indicator or disable the link if needed
      
      Api.downloadInvitationsTemplate()
        .then(response => {
          // Create a blob from the response
          const blob = new Blob([response.data], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
          });
          
          // Create a URL for the blob
          const url = window.URL.createObjectURL(blob);
          
          // Create a temporary link element
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'invitation_template.xlsx');
          
          // Append to the document, click, and remove
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          // Clean up the blob URL
          window.URL.revokeObjectURL(url);
        })
        .catch(error => {
          // Handle error
          this.$swal({
            icon: "error",
            title: "Error",
            text: "Failed to download template",
            showConfirmButton: true,
            confirmButtonColor: '#0A0446'
          });
        });
    },
    
    getInvitedEmployeesList: function (page = 1) {
      let that = this
      Api.getAdminInvitationList(page, that.getEmpData).then(response => {
        let that = this
        that.isTableLoading = false;
        that.employeesList = response.data.data
        that.employeesLength = that.employeesList.data.length
      })
    },
    getInvitationLink(userId, surveyInviteLink) {
      // If there's a specific survey invite link, use it
      if (surveyInviteLink) {
        return `${this.baseUrl}/assessment-welcome/${surveyInviteLink}`;
      }
      
      // Fallback to user ID if no specific link is available
      return `${this.baseUrl}/assessment-welcome/${userId}`;
    },
  
    copyInvitationLink(userId) {
      const linkElement = document.getElementById(`invite-link-${userId}`);
      if (linkElement) {
        linkElement.select();
        document.execCommand('copy');
        
        // Show the copied state
        this.copiedLinkId = userId;
        
        // Reset the copied state after 2 seconds
        setTimeout(() => {
          if (this.copiedLinkId === userId) {
            this.copiedLinkId = null;
          }
        }, 2000);
      }
    },

    copyPublicAssessmentLink() {
      // Create a temporary textarea element to hold the URL
      const textArea = document.createElement('textarea');
      textArea.value = this.publicAssessmentUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      
      // Show the copied state
      this.isPublicLinkCopied = true;
      
      // Reset the copied state after 2 seconds
      setTimeout(() => {
        this.isPublicLinkCopied = false;
      }, 2000);
    }
  },
  mounted() {
    this.getInvitedEmployeesList()
  }
}
</script>

<style scoped>
.modal-body .btn-primary {
  background-color: #0A0446 !important;
  border-color: #0A0446 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/survey/SurveyInvite.vue